import { render, staticRenderFns } from "./userAvatar.vue?vue&type=template&id=623ac6af&"
import script from "./userAvatar.vue?vue&type=script&lang=ts&"
export * from "./userAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./userAvatar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports